import React from "react";
import Modal from "../../../components/common/Modal";

function LSPModal({ open, setOpen }) {
  return (
    <div className="invoice-modal">
      {open && (
        <Modal
          size="xl"
          title="LSP Calculation"
          show={open === "lspCalculation" ? true : false}
          handleClose={() => setOpen("")}
        >
          <iframe
            title="TeBoard_LSP_SBP"
            width="100%"  // This will make the iframe take up full width of the modal
            height="500px" // Adjust the height as needed
            src="https://app.powerbi.com/view?r=eyJrIjoiMGU4NTJjMzItODgxMS00NjI5LWFhY2MtY2Y0OTAxYTQ2NDRhIiwidCI6IjZkZDQzMGI4LTNkZWYtNGY4ZC1hYzU0LTlmZTFlMDI2MGFiOSJ9"
            frameBorder="0"
            allowFullScreen="true"
          ></iframe>
        </Modal>
      )}
    </div>
  );
}

export default LSPModal;
